import Logger from '../logger';

class Base {
    _connect(superstore, key) {
        var _ = this;

        Object.defineProperty(_, '_superstore', {
            value: superstore,
            enumerable: false,
            writable: false
        });

        _.logger = new Logger({
            debug: superstore.logger.debug,
            logger: superstore.logger,
            prefix: _.constructor.name + ':' + key + ' ~>',
        });

        _.logger.log('connected', _);

        return _;
    }

    query() {
        var _ = this;

        return new Promise(function(resolve) {
            _.logger.warn('`query` not implemented');
            resolve();
        });
    }

    find() {
        var _ = this;

        return new Promise(function(resolve) {
            _.logger.warn('`find` not implemented');
            resolve();
        });
    }

    save() {
        var _ = this;

        return new Promise(function(resolve) {
            _.logger.warn('`save` not implemented');
            resolve();
        });
    }

    destroy() {
        var _ = this;

        return new Promise(function(resolve) {
            _.logger.warn('`destroy` not implemented');
            resolve();
        });
    }
}

export default Base;
